import { Eleicao } from "./eleicao.model";

export class CargoCsvDTO  {

    constructor(
        public nome?: string,
        public informacao?: string,
        public qtdElegiveis?: number,  
        public eleicao?: Eleicao,
        public labelCargo?: string,
        public plano?: string,
        public agrupador?: string
    ) {}
 
}